import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    cn,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@repo/shadcn';
import { Check, ChevronsUpDown } from 'lucide-react';
import * as React from 'react';
import { useController } from 'react-hook-form';

interface AutoCompleteProps {
    value: string;
    label: string;
}
interface Props {
    options: AutoCompleteProps[];
    control: any;
    name: string;
}

export const AutoComplete: React.FC<Props> = ({
    options = [],
    control,
    name,
}) => {
    const { field } = useController({ name, control });
    const [open, setOpen] = React.useState(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between capitalize"
                >
                    {field.value
                        ? options.find((option) => option.value === field.value)
                              ?.label
                        : 'Select options...'}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[300px] p-0">
                <Command>
                    <CommandInput placeholder="Search options..." />
                    <CommandList>
                        <CommandEmpty>No options found.</CommandEmpty>
                        <CommandGroup>
                            {options.map((option) => (
                                <CommandItem
                                    key={option.value}
                                    className=" capitalize"
                                    value={option.value}
                                    onSelect={(currentValue) => {
                                        field.onChange(
                                            currentValue === field.value
                                                ? ''
                                                : currentValue,
                                        );
                                        setOpen(false);
                                    }}
                                >
                                    <Check
                                        className={cn(
                                            'mr-2 h-4 w-4',
                                            field.value === option.value
                                                ? 'opacity-100'
                                                : 'opacity-0',
                                        )}
                                    />
                                    {option.label}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
};
